import {env} from 'next-runtime-env';
import AxiosClient from 'axios';
// import Axios from 'axios';

const NEXT_PUBLIC_GATEWAY_API_URL = env('NEXT_PUBLIC_GATEWAY_API_URL');

const Axios = AxiosClient.create({
  baseURL: NEXT_PUBLIC_GATEWAY_API_URL,
});

Axios.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${localStorage.getItem('gatewayToken')}`;
  return config;
});

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async registerWithEmail(params: {
    email: string;
    displayName: string;
    password: string;
    referralCode: string;
  }) {
    // const response = await client.post('/v2/player/register-with-email', params);
    const response = await Axios.post(`/v1/users/register-with-email`, params, {
      withCredentials: true,
    });
    return response.data;
  },

  async loginWithEmail(params: {email: string; password: string}) {
    // const response = await client.post('/v2/player/login-with-email', params);
    const response = await Axios.post(`/v1/users/login-with-email`, params, {
      withCredentials: true,
    });

    return response.data;
  },

  async getEmailOtp(email: string) {
    const response = await Axios.post(`/v1/users/send-email-verify-code`, {
      email,
    });
    return response.data;
  },

  async loginEmailWithOtp({email, otp}: {email: string; otp: string}) {
    const response = await Axios.post(`/v1/users/login-with-email`, {
      email,
      passCode: otp,
    });
    console.log('@loginEmailWithOtp:response.gatewayToken', response?.data?.data?.gatewayToken);
    window.localStorage.setItem('gatewayToken', response?.data?.data?.gatewayToken);
    return response.data;
  },

  async verifyEmail(params: {token: string}) {
    // const response = await client.post('/v2/player/verify-email', params);
    const response = await Axios.post(`/v1/users/verify-email`, params, {
      withCredentials: true,
    });
    return response.data;
  },

  async resendVerificationEmail(params: {token: string}) {
    // const response = await client.get('/v2/player/resend-register-email-verify-code', {
    //   headers: {'player-token': params.token},
    // });
    const response = await Axios.get(`/v1/users/resend-register-email-verify-code`, {
      headers: {'player-token': params.token},
    });
    return response.data;
  },

  async resendResetPasswordEmail(params: {email: string}) {
    // const response = await client.post('/v2/player/send-reset-password-email', params);
    const response = await Axios.post(`/v1/users/send-reset-password-email`, params, {
      withCredentials: true,
    });
    return response.data;
  },

  async resetPassword(params: {password: string; verificationToken: string}) {
    // const response = await client.post('/v2/player/reset-password', params);
    const response = await Axios.post(`/v1/users/reset-password`, params, {
      withCredentials: true,
    });
    return response.data;
  },

  // MetaMask
  async getNonce(params: {walletAddress: string}) {
    // const response = await client.post('/v2/player/metamask-nonce', params);
    const response = await Axios.post(`/v1/users/metamask-nonce`, params, {
      withCredentials: true,
    });
    return response.data;
  },
  async getWalletConnectNonce() {
    // const response = await client.post('/v2/player/metamask-nonce', params);
    const response = await Axios.get(`/v1/users/wallet-connect-nonce`, {
      withCredentials: true,
    });
    return response.data;
  },

  // TODO @@ walletConnect
  async walletUserLogout() {
    // const response = await client.post('/v2/player/metamask-nonce', params);
    const response = await Axios.get(`/v1/users/logout`, {
      withCredentials: true,
    });
    return response.data;
  },

  async getWalletConnectSession() {
    // const response = await client.post('/v2/player/metamask-nonce', params);
    const response = await Axios.get(`/v1/users/wallet-connect-session`, {
      withCredentials: true,
    });
    if (response?.data?.data?.gatewayToken) {
      window.localStorage.setItem('gatewayToken', response?.data?.data?.gatewayToken);
    }
    if (response?.data?.data?.playerToken) {
      window.localStorage.setItem('playerToken', response?.data?.data?.playerToken);
    }

    return response.data;
  },

  async loginWithMetaMask(params: {walletAddress: string; signature: string}) {
    // const response = await client.post('/v2/player/login-with-metamask', params);
    const response = await Axios.post(`/v1/users/login-with-metamask`, params, {
      withCredentials: true,
    });
    window.localStorage.setItem('gatewayToken', response?.data?.data?.gatewayToken);
    window.localStorage.setItem('playerToken', response?.data?.data?.playerToken);

    return response.data;
  },

  async loginWithWalletConnect(params: {message: string; signature: string}) {
    const response = await Axios.post(`/v1/users/login-with-wallet-connect`, params, {
      withCredentials: true,
    });

    window.localStorage.setItem('gatewayToken', response?.data?.data?.gatewayToken);
    window.localStorage.setItem('playerToken', response?.data?.data?.playerToken);

    return response.data;
  },

  async completeRegistrationWithMetaMask(
    params: {
      displayName: string;
      referralCode?: string;
    },
    playerToken: string
  ) {
    // const response = await client.post('/v2/player/complete-registration-with-metamask',
    const response = await Axios.post(`/v1/users/complete-registration-with-metamask`, params, {
      withCredentials: true,
    });
    return response.data;
  },

  async completeRegistrationWithEmail(params?: {referralCode?: string}) {
    const response = await Axios.post(
      `/v1/users/complete-registration-with-email`,
      {referralCode: params?.referralCode || ''},
      {
        withCredentials: true,
      }
    );
    return response.data;
  },

  async completeRegistrationWithWalletConnect(params?: {referralCode?: string}) {
    const response = await Axios.post(
      `/v1/users/complete-registration-with-wallet-connect`,
      {referralCode: params?.referralCode || ''},
      {
        withCredentials: true,
      }
    );
    return response.data;
  },

  async depositAddress(params: {networkTokenId?: string} = {networkTokenId: 'USDT_ETH'}) {
    const response = await Axios.get(`/v1/users/deposit-address/${params.networkTokenId}`, {
      withCredentials: true,
    });
    return response.data;
  },

  async withdraw(params: {
    address: string;
    amount: number;
    accessToken: string;
    totpPassCode?: string;
    networkTokenId: string;
    memo?: string;
  }) {
    const response = await Axios.post(`/v1/users/withdraw`, params, {
      withCredentials: true,
    });
    return response.data;
  },

  // TODO @@ rename
  async postPlayerInfo(params: {accessToken: string}) {
    const response = await Axios.get(`/v1/users/player-info`, {
      withCredentials: true,
    });
    return response.data;
  },

  async completeRegistrationWithMetamask(params: {displayName: string; referralCode: string}) {
    const response = await Axios.post(`/v1/users/complete-registration-with-metamask`, params, {
      withCredentials: true,
    });
    return response.data;
  },

  async getFundHistory(params: {page: number; type: 'DEPOSIT' | 'WITHDRAWAL' | null}) {
    const query = `?page=${params.page}${params.type ? `&type=${params.type}` : ''}`;
    const response = await Axios.get(`/v1/users/fund-txn${query}`, {
      withCredentials: true,
    });
    return response.data;
  },

  async getOneGatewayTransactionHistory(params: {id: number}) {
    const response = await Axios.get(`/v1/users/transactions/${params?.id}`, {
      withCredentials: true,
    });
    return response.data;
  },

  async getDepositInfo() {
    const response = await Axios.get(`/v1/users/deposit-info`, {
      withCredentials: true,
    });
    return response.data.data;
  },

  async getWithdrawalInfo() {
    const response = await Axios.get(`/v1/users/withdrawal-info`, {
      withCredentials: true,
    });
    return response.data;
  },

  async logOut() {
    const response = await Axios.get(`/v1/users/logout`, {
      withCredentials: true,
    });
    return response.data;
  },

  // TOTP
  async getTOTPEmailVerificationCode() {
    const response = await Axios.get(`/v1/users/send-otp-email-verify-code`, {
      withCredentials: true,
    });
    return response.data;
  },

  async verifyTOTPEmailVerificationCode(params: {passCode: string}) {
    const response = await Axios.post(`/v1/users/verify-otp-email-verify-code`, params, {
      withCredentials: true,
    });
    return response.data;
  },

  async verifyTOTP(params: {passCode: string}) {
    const response = await Axios.post(`/v1/users/verify-totp`, params, {
      withCredentials: true,
    });
    return response.data;
  },

  // KYC
  async getCountryList() {
    const response = await Axios.get(`/v1/users/country-list`);
    return response.data;
  },
  async submitKycIdDocs(params: {
    issuingCountry: string;
    documentType: 'driver_license' | 'id_card' | 'passport' | 'residence_permit';
    frontImage: File;
    backImage?: File;
  }) {
    const data = new FormData();
    for (const [key, value] of Object.entries(params)) {
      data.append(key, value);
    }
    const response = await Axios.post(`/v1/users/submit-kyc-id-docs`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
  async disableTOTP(params: {passCode: string}) {
    const response = await Axios.post(`/v1/users/disable-totp`, params, {
      withCredentials: true,
    });
    return response.data;
  },
  async sendKycEmailVerificationCode(params: {email: string}) {
    const response = await Axios.post(`/v1/users/send-kyc-email-verification`, params, {
      withCredentials: true,
    });
    return response.data;
  },
  async verifyKycEmailVerificationCode(params: {passCode: string}) {
    const response = await Axios.post(`/v1/users/kyc-email-verification`, params, {
      withCredentials: true,
    });
    return response.data;
  },

  async loginWithTelegramMiniApp(params: {initData: string; referralCode?: string}) {
    const response = await Axios.post(`/v1/users/login-with-telegram-mini-app`, params, {
      withCredentials: true,
    });

    return response.data;
  },

  async sendLinkEmailVerifyCode(params: {email: string}) {
    const response = await Axios.post(`/v1/users/send-link-email-verify-code`, params, {
      withCredentials: true,
    });

    return response.data;
  },

  async linkEmailVerifyCode(params: {email: string; passCode: string}) {
    const response = await Axios.post(`/v1/users/link-email-verify-code`, params, {
      withCredentials: true,
    });

    return response.data;
  },
};
